import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import SearchableSelect from "../common/SearchableSelect";

import "./Modal.scss";
import {
	apenasNumeros,
	chaveAcessoPretty,
	getCorretData,
	getMotivosPedidoNaoEntregue,
	getStatusPedidos,
	numerosDecimal,
	numerosEditadoBR,
	valorMoeda,
} from "../../services/Servicos";
import { telefoneMask } from "../../services/helpers";

export default function ModalEditarRow(props) {
	const user = useSelector((state) => state.userSlice);
	const handlerSimpleClose = () => props.setShow((last) => ({ show: false }));

	const [body, setBody] = useState(props.row);
	const [btn, setBtn] = useState({
		flag: false,
		style: "primary",
		msg: "Salvar",
	});
	const [bodyEdit, setBodyEdit] = useState({});
	const [params, setParams] = useState(
		Object.keys(props.row).map((item) => item)
	);

	// Options for SearchableSelect components
	const tipoOptions = [
		{ value: "ENTREGAR AO CLIENTE", label: "Entregar ao Cliente" },
		{ value: "ENTREGAR NA LOJA", label: "Entregar na Loja" },
		{ value: "RETIRAR NA LOJA", label: "Cliente Retira na Loja" }
	];

	const statusOptions = 
	Array.from({ length: 40 }, (_, i) => i - 3).map((value) => ({
		value: String(value),
		label: `${value} - ${getStatusPedidos(value)}`,
		exists: getStatusPedidos(value) ? true : false
	}));
	const getMotivosPedidoNaoEntregueOptions = 
	Array.from({ length: 10 }, (_, i) => i + 1).map((value) => ({
		value: getMotivosPedidoNaoEntregue(value),
		label: `${value} - ${getMotivosPedidoNaoEntregue(value)}`,
		exists: getMotivosPedidoNaoEntregue(value) != 'NÃO DEFINIDO'? true : false
	}));

	const getEditedValue = (params, value) => {
		if (["emissao", "createdAt", "updatedAt"].includes(params))
			return getCorretData(value);
		if (params == "id_filial")
			return (
				user.filiaisList.data.find((item) => item.idFilial == value)
					?.identificacaoInterna || value
			);
		if (params == "romaneio") return String(value).padStart(7, "0");
		if (params == "peso_nf") return numerosEditadoBR(value);
		if (params == "valor_total") return valorMoeda(value);
		if (params == "chave_nfe") return chaveAcessoPretty(value);
		return value;
	};

	const changeValue = (params, value) => {
		if (params.includes("tel_"))
			return setBodyEdit((last) => ({
				...last,
				[params]: telefoneMask(value),
			}));
		if (params.includes("peso_nf"))
			return setBodyEdit((last) => ({
				...last,
				[params]: Number(
					numerosDecimal(apenasNumeros(value)).replace(",", ".")
				).toLocaleString("pt-br", { minimumFractionDigits: 2 }),
			}));
		if (params.includes("valor_total"))
			return setBodyEdit((last) => ({
				...last,
				[params]: valorMoeda(
					numerosDecimal(apenasNumeros(value)).replace(",", ".")
				).toLocaleString("pt-br", { minimumFractionDigits: 2 }),
			}));
		if (params.includes("chave_nfe"))
			return setBodyEdit((last) => ({
				...last,
				[params]: chaveAcessoPretty(value),
			}));
		setBodyEdit((last) => ({ ...last, [params]: value }));
	};

	const atualizarPedido = async () => {
		if (!bodyEdit) return;
		setBtn({ flag: true, msg: "Carregando", style: "warning" });

		if (bodyEdit.peso_nf) {
			bodyEdit.peso_nf = bodyEdit.peso_nf.replaceAll('.','').replaceAll(',','.')
		}
		if (bodyEdit.valor_total) {
			bodyEdit.valor_total = bodyEdit.valor_total.replaceAll('.','').replaceAll(',','.')
		}
		if (bodyEdit.chave_nfe) {
			bodyEdit.chave_nfe = bodyEdit.chave_nfe.replaceAll(' ','')
		}
		await props.fnRetorno(
			{ ...bodyEdit, cargas_id: body.cargas_id },
			body.romaneio
		);
		setBtn({ flag: false, msg: "Salvo", style: "success" });

		setTimeout(() => {
			setBtn({ flag: false, msg: "Salvar", style: "primary" });
			props.setShow(false)
		}, 1000);
	};

	return (
		<>
			<Modal
				show={props.show}
				onHide={handlerSimpleClose}
				backdrop="static"
				keyboard={false}
				centered
				size="lg"
			>
				<Modal.Header closeButton>
					<Modal.Title>{props.title || "TITULO NÃO INFORMADO"}</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ overflow: "hidden", margin: "0 20px" }}>
					<Form>
						{params
							.filter(
								(item) =>
									![
										"empresas_id",
										"responsavel",
										"cpf_responsavel",
										"createdAt",
										"created_at",
										"updatedAt",
										"updated_at",
										// "danfe",
										// "foto_pedido_entregue",
										"qr_code_id",
										"data_fim_descarregamento",
										"data_inicio_descarregamento",
										"cargas_id",
										"metros_quadrado",
										"data_cancelamento",
									].includes(item)
							)
							.map((item) => (
								<Row className="mb-2" key={item}>
									<Col sm="3">{item}:</Col>
									<Col>
										{item == "tipo" ? (
											<SearchableSelect
												options={tipoOptions}
												value={bodyEdit[item] || getEditedValue(item, body[item])}
												onChange={(e) =>
													setBodyEdit((last) => ({
														...last,
														[item]: e.target.value,
													}))
												}
												name={item}
												placeholder="Selecione o tipo..."
												searchPlaceholder="Buscar tipo..."
												getOptionValue={(option) => option.value}
												getOptionLabel={(option) => option.label}
												renderOption={(option) => option.label}
											/>
										) : item == "status" ? (
											<SearchableSelect
												options={statusOptions.filter((option) => option.exists)}
												value={bodyEdit[item] || getEditedValue(item, body[item])}
												onChange={(e) =>
													setBodyEdit((last) => ({
														...last,
														[item]: e.target.value,
													}))
												}
												name={item}
												placeholder="Selecione o status..."
												searchPlaceholder="Buscar status..."
												getOptionValue={(option) => option.value}
												getOptionLabel={(option) => option.label}
												renderOption={(option) => option.label}
											/>
										) : item == "motivo" ? (
											<SearchableSelect
												options={getMotivosPedidoNaoEntregueOptions.filter((option) => option.exists)}
												value={bodyEdit[item] || getEditedValue(item, body[item])}
												onChange={(e) =>
													setBodyEdit((last) => ({
														...last,
														[item]: e.target.value,
													}))
												}
												name={item}
												placeholder="Selecione o status..."
												searchPlaceholder="Buscar status..."
												getOptionValue={(option) => option.value}
												getOptionLabel={(option) => option.label}
												renderOption={(option) => option.label}
											/>
										) : item == "outros_motivo" ? (
											<Form.Control
												defaultValue={getEditedValue(item, body[item])}
												value={bodyEdit[item]}
												disabled={bodyEdit.motivo != "Outros"}
												onChange={(e) => changeValue(item, e.target.value)}
											/>
										) : (
											<Form.Control
												defaultValue={getEditedValue(item, body[item])}
												value={bodyEdit[item]}
												disabled={[
													"emissao",
													"id_filial",
													"romaneio",
													"numero_pedido",
													"nome_vendedor",
												].includes(item)}
												onChange={(e) => changeValue(item, e.target.value)}
											/>
										)}
									</Col>
								</Row>
							))}
					</Form>
				</Modal.Body>
				<Modal.Footer className="d-flex flex-row">
					<Button
						variant={btn.style}
						onClick={atualizarPedido}
						style={{ width: "fit-content", paddingInline: "40px" }}
					>
						{btn.msg}
						{btn.style == "success" ? <i className="bi bi-check"></i> : ""}
						{btn.style == "warning" ? (
							<Spinner size="sm" animation="border" color="black" />
						) : (
							""
						)}
					</Button>
					<Button
						variant="secondary"
						onClick={handlerSimpleClose}
						style={{ width: "fit-content", paddingInline: "40px" }}
					>
						Fechar
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
}
